// @ts-check

import { checkArrayWithEmpty } from 'libs/types/checkTypes';

/**
 * @function filterUserGroups
 * @param {Object[]} groups
 * @param {string} groups.id
 * @param {string} groups.name
 * @param {string} groups.appId
 * @param {string} groups.appName
 * @param {Object[]} loggedinUserGroups
 * @param {string} loggedinUserGroups.userId
 * @param {string} loggedinUserGroups.roleGroupId
 * @returns {Array.<{id:String, name:String, appId:String, appName:String}>}
 */
function filterUserGroups(groups, loggedinUserGroups) {
	checkArrayWithEmpty(groups, loggedinUserGroups);

	const filteredByAppId = groups.filter((group) =>
		loggedinUserGroups.some((userGroup) => group.id === userGroup.roleGroupId),
	);

	const filteredGroups = groups.filter((group) =>
		filteredByAppId.some((userGroup) => group.appId === userGroup.appId),
	);

	return filteredGroups;
}

export default filterUserGroups;
